export default __webpack_public_path__ + "static/media/mario.9c505613.png";